/**
 * SettingRow - Reusable setting item component
 * Based on mobile app SettingsScreen.tsx
 */

import { ChevronRight } from 'lucide-react'

interface SettingRowProps {
  title: string
  subtitle?: string
  icon?: React.ReactNode
  type?: 'navigation' | 'toggle'
  value?: boolean
  onChange?: (value: boolean) => void
  onClick?: () => void
  danger?: boolean
}

export default function SettingRow({
  title,
  subtitle,
  icon,
  type = 'navigation',
  value,
  onChange,
  onClick,
  danger = false,
}: SettingRowProps) {
  const handleToggleClick = (e: React.MouseEvent) => {
    e.stopPropagation()
    if (onChange) {
      onChange(!value)
    }
  }

  return (
    <button
      onClick={type === 'navigation' ? onClick : undefined}
      className="w-full flex items-center gap-3 px-4 py-3 hover:bg-gray-50 transition-colors text-left"
    >
      {/* Icon */}
      {icon && (
        <div className={`flex-shrink-0 ${danger ? 'text-error' : 'text-text-secondary'}`}>
          {icon}
        </div>
      )}

      {/* Text Content */}
      <div className="flex-1 min-w-0">
        <div className={`font-medium ${danger ? 'text-error' : 'text-gray-900'}`}>
          {title}
        </div>
        {subtitle && (
          <div className="text-small text-text-secondary">
            {subtitle}
          </div>
        )}
      </div>

      {/* Right Side - Toggle or Chevron */}
      {type === 'toggle' ? (
        <div
          onClick={handleToggleClick}
          className={`
            relative inline-flex h-6 w-11 items-center rounded-full transition-colors
            ${value ? 'bg-onrecord-orange' : 'bg-gray-300'}
          `}
        >
          <span
            className={`
              inline-block h-4 w-4 transform rounded-full bg-white transition-transform
              ${value ? 'translate-x-6' : 'translate-x-1'}
            `}
          />
        </div>
      ) : (
        <ChevronRight className="w-5 h-5 text-text-secondary flex-shrink-0" />
      )}
    </button>
  )
}
